export default function calculateExamScore(exam) {
	return Math.round(
		((exam.iloscPoprawnieRozwiazanychPytan || 0) * 100) /
			(exam.iloscWszystkichPytan || 1),
	);
}

export function calculateCourseScore(row) {
	if (!row?.lessons) return 0;

	const resolvedItems = row.lessons.filter(
		(lesson) => lesson.status === "resolved",
	);

	return row.lessons.length > 0
		? Math.round((resolvedItems.length * 100) / row.lessons.length)
		: 0;
}
